import React from "react";
import Navbar from "../navbar";
import "./heroSection.css";
import heroSectionDesktopImage from "./image/heroSectionDesktop.webp";
import heroSectionMobileImage from "./image/heroSectionMobile.webp";

const HeroSection = () => {
  return (
    <div className="hero-section" id="home">
      <Navbar />

      {/* Desktop Image */}
      <div className="desktop-image-wrapper">
        <img
          className="vedio-largeScreen"
          src={heroSectionDesktopImage}
          alt="Hero Desktop"
        />
      </div>

      {/* Mobile Image */}
      <div className="vedio-smallScreen">
        <img
          src={heroSectionMobileImage}
          alt="Hero Mobile"
          className="mobile-hero-img"
        />
      </div>
    </div>
  );
};

export default HeroSection;

// import React from "react";
// import Navbar from "../navbar";
// import "./heroSection.css";
// import Image from "../heroSection/image/heroSectionImage.jpg";
// import CameraManVedio from "./image/cameraManVedio.mp4";
// import SmallScreenVedio from "./image/Vertical-Vedio-Tab.mp4";
// import heroSectionDesktopImage from "./image/heroSectionDesktop.png";
// import heroSectionMobileImage from "./image/heroSectionMobile.png";

// const HeroSection = () => {
//   return (
//     <div className="hero-section" id="home">
//       <Navbar />
//       <video
//         className="vedio-largeScreen"
//         autoPlay
//         loop
//         muted
//         playsInline
//         src={CameraManVedio}
//       ></video>

//       <div className="vedio-smallScreen">
//         <video autoPlay loop muted playsInline src={SmallScreenVedio}></video>
//       </div>
//     </div>
//   );
// };

// export default HeroSection;
